<div class="video-gallery">
{#each data as url_string}
    <div class="video-div" style="background-color: black;">
         <iframe
            title={url_string}
            width='560'
            height='315'
            frameborder='0'
            allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
            allowfullscreen=true
            src={format_url(url_string)}
            class="video"
            ></iframe>
    </div>
{:else}
    <p>No videos found</p>
{/each}
</div>

<script>
    export let data = [];
    const content = document.getElementById("content");

    fetch('video_links.txt')
    .then(response => response.text())
    .then((text) => data = text.split("\n"))
    
    function format_url(url_string) {
        const url = new URL(url_string)
        if (url.hostname.includes("youtube") || url.hostname.includes("youtu.be")) {
            return `https://www.youtube.com/embed/${url.searchParams.get('v')}`
        } else if (url.hostname.includes("vimeo")) {
            return `https://player.vimeo.com/video/${url.pathname.substring(1)}?color=ffffff`
        } else {
            throw "No YouTube of Vimeo link!"
        }
    }
</script>
